import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import "./header.css"

const Header = (props : {body : string, image: string}) => {
    let image = `url(${props.image})`;

    return <header style={{backgroundImage: image }}>
      <div>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>
        {props.body}
      </ReactMarkdown>
      </div>
    </header>
}

export default Header